import { addDatasourcesToResult, analyse } from './ImportReportConfig.Helpers';
import { getCollections, getDataSources, getDataSourcesByNames, importDataSources, importReportConfig } from './ServerCalls';
import { validateUpdate } from './ImportReportConfig.Validation';
import CollectionBundle from './Types/CollectionBundle';
import DataSourceAnalysisResult from './Types/DataSourceAnalysisResult';
import dataSourceFieldMapHelper from '../../../infrastructure/helpers/report/import/dataSourceFieldMapHelper';
import ErrorList from '../../Common/ErrorList/ErrorList';
import IdMaps from '../../../types/report/import/IdMaps';
import ImportReportConfigState from './ImportReportConfigState';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import React from 'react';
import ReportConfig from '../../../types/report/ReportConfig';
import reportConfigAdapter from '../../../infrastructure/helpers/report/import/reportConfigAdapter';
import ReportConfigBundle from '../../../types/report/import/ReportConfigBundle';
import reportConfigComponentIdMapper from '../../../infrastructure/helpers/report/import/reportConfigComponentIdMapper';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import ChangeLogModal from '../../Common/Modals/ChangeLogModal/ChangeLogModal';
import store from '../../../store/store';
import ChangeLogModalState from '../../Common/Modals/ChangeLogModal/ChangeLogModalState';
import { commonColumns, moduleColumn, moduleRefColumn } from '../../Common/Modals/ChangeLogModal/ChangeLogModal.Grid';
import actions from '../../../store/actions';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import ChangeDescription from '../../../infrastructure/types/DifferenceVisualizer/ChangeDescription';
import reportConfigBundleSerializer from '../../../infrastructure/helpers/report/import/reportConfigBundleSerializer';
import WarningModal from '../../Common/Modals/WarningModal/WarningModal';
import FormGroup from '../../Common/FormGroup/FormGroup';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import stringHelper from '../../../infrastructure/helpers/common/stringHelper';
import NameAndError from '../../../types/report/import/NameAndError';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import Spinner from '../../Common/Spinner/Spinner';
import { reportType } from '../../../infrastructure/constants/reportType';
import GlobalModuleConfig from '../../../types/report/GlobalModuleConfig';
import GlobalModuleComponentsAnalysisResult from './Types/GlobalModuleComponentsAnalysisResult';
import IdNameAndNumber from '../../../types/report/IdNameAndNumber';
import RefDataSource from '../../../types/report/RefDataSource';
import editReportConfigHelper from '../../../infrastructure/helpers/report/editReportConfigHelper';
import './styles.scss';
import GlobalModuleComponents from './GlobalModuleComponents';
import { analyseGlobalModuleComponents, createGlobalModule, getComponentNameExistsError, getCurrentGlobalModuleConfig, resetConfigComponentsBeforeGetChanges, updateLookupsDataSources } from './GlobalModule.Helpers';
import ReportVariable from '../../../types/report/ReportVariable';
import Lookup from '../../../types/functions/Lookup';
import { getEmptyReportConfig } from '../Pages/ReportPage/ReportPage.Helpers';
import ComparisonPair from './Types/ComparisonPair';
import ComponentInPopup from './Types/ComponentInPopup';
import ComponentType from '../../../types/report/ComponentType';
import { getReferencedGlobalLookups } from '../Lookup/LookupBuilder.Helpers';
import operandHelper from '../../../infrastructure/helpers/functions/operand/operandHelper';
import Operand from '../../../types/functions/Operand/Operand';
import ImportConfigState from './Types/ImportConfigState';
import Mode from '../../../types/report/Mode';
import userDefinedFunctionHelper from '../UserDefinedFunctions/UserDefinedFunctionHelper';
import Assignment from '../../../types/functions/Assignment/Assignment';
import Condition from '../../../types/functions/Condition/Condition';
import Config from '../../../types/report/Config';

interface Props {
    isValidationConfig: boolean;
    state: ImportReportConfigState;
    onChange: (changes: ImportReportConfigState) => void;
    onImportSuccess: () => void;
    skipDataSourcesValidation?: boolean;
    title: string;
    isOpen: boolean
}

const emptyName = 'Please type name';
const inavlidJsonError = 'Invalid Json.';

class ImportReportConfig extends React.Component<Props, ImportConfigState> {
    constructor(props: Props) {
        super(props);

        this.onSourceChange = this.onSourceChange.bind(this);
        this.onImportClick = this.onImportClick.bind(this);
        this.getAndSetDataSources = this.getAndSetDataSources.bind(this);

        this.notifyUser = this.notifyUser.bind(this);
        this.showChanges = this.showChanges.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onDownloadClick = this.onDownloadClick.bind(this);
        this.onImportConfigConfirmed = this.onImportConfigConfirmed.bind(this);
        this.onNewDataSourceNamesReady = this.onNewDataSourceNamesReady.bind(this);
        this.getNewDataSourceJsx = this.getNewDataSourceJsx.bind(this);
        this.onDataSourceRename = this.onDataSourceRename.bind(this);
        this.getRenameJsx = this.getRenameJsx.bind(this);
        this.onReportNameChangeConfirmed = this.onReportNameChangeConfirmed.bind(this);
        this.closeNewDataSourceNameModal = this.closeNewDataSourceNameModal.bind(this);
        this.onMismatchedGlobalComponentsOkClick = this.onMismatchedGlobalComponentsOkClick.bind(this);
        this.onShowDiffClick = this.onShowDiffClick.bind(this);
        this.setState = this.setState.bind(this);


        this.state = {
            toImport: {} as ReportConfig,
            errors: [],
            dataSourceAnalysisResult: {} as DataSourceAnalysisResult,
            showImportDataSourceModal: false,
            message: '',
            bundle: {} as ReportConfigBundle,
            showNewDataSourcesNamesModal: false,
            mismatchedDataSources: [],
            renamedDataSources: new Map(),
            reportNameError: '',
            showNewConfigNamePopup: false,
            reportNewName: '',
            dataSourcesInDb: [],
            validationConfig: null,
            globalModuleComponentsAnalysisResult: {} as GlobalModuleComponentsAnalysisResult,
            currentGlobalModuleConfig: {} as GlobalModuleConfig,
            showSpinner: this.props.isOpen,
            compareChanges: {} as ChangeDescription,
            showEditGlobalComponentsPopup: false,
            componentsChanges: [],
            isOpen: true,
            originalConfig: {} as ReportConfig
        };
    }

    componentDidUpdate(prevPros: Props) {
        if (prevPros.isOpen !== this.props.isOpen && !this.props.isOpen) {
            this.setState({ isOpen: false, showEditGlobalComponentsPopup: false });
        }
    }

    onSourceChange(e: React.ChangeEvent<HTMLInputElement>): void {

        this.props.onChange({ json: e.target.value } as ImportReportConfigState);
    }

    async onImportClick(): Promise<void> {

        let bundle = { error: '' } as ReportConfigBundle;

        try {
            bundle = reportConfigBundleSerializer.deserialize(this.props.state.json, this.props.skipDataSourcesValidation);

            editReportConfigHelper.prepare(bundle.config, bundle.dataSources);
        }
        catch (error) {
            bundle.error = inavlidJsonError;
        }

        if (bundle.error) {
            let message = inavlidJsonError;

            this.props.onChange({ errors: [message] } as ImportReportConfigState);
        }
        else if (this.props.isValidationConfig !== (bundle.config.type === reportType.accuracy)) {
            let message = `It is not allowed to import ${bundle.config.type} kind of config on this page.`;

            this.props.onChange({ errors: [message] } as ImportReportConfigState);
        }
        else {

            let currentGlobalModuleConfig = await getCurrentGlobalModuleConfig();

            let isGlobalComponentUsed = this.isGlobalComponentUsed(bundle.config);

            if ((!currentGlobalModuleConfig || Object.keys(currentGlobalModuleConfig).length === 0) && isGlobalComponentUsed) {
                currentGlobalModuleConfig = await createGlobalModule();
            }

            if (currentGlobalModuleConfig) {

                this.setState({ currentGlobalModuleConfig } as ImportConfigState);
            }

            this.setState({ originalConfig: copyObject(bundle.config) });

            if (!this.props.isValidationConfig) {
                httpClient.get<boolean>(`report/validate-name/${bundle.config.name}`)
                    .then((resp) => {

                        if (resp.data) {
                            this.setState({
                                reportNameError: '',
                                bundle,
                                showNewConfigNamePopup: true
                            });
                        }
                        else {
                            this.proceedWithImport(bundle);
                        }
                    });
            }
            else {
                this.proceedWithImport(bundle);
            }
        }
    }

    isGlobalComponentUsed(config: ReportConfig): boolean {
        let isGlobalComponentUsed = config.lookups.find(x => x.mode === Mode.Global)
            || config.variables.find(x => x.mode === Mode.Global);

        if (isGlobalComponentUsed) {

            return true;
        }

        let referencedFunctions = userDefinedFunctionHelper.findGlobalUserDefinedFunctionsReferences(config);

        return referencedFunctions.length > 0;
    }

    proceedWithImport(bundle: ReportConfigBundle) {
        this.setState({ bundle, showSpinner: true });

        if (!bundle.error) {

            this.getAndSetDataSources(bundle);
        }
        else {
            this.props.onChange({ errors: [bundle.error] } as ImportReportConfigState);
        }
    }

    async getAndSetDataSources(bundle: ReportConfigBundle): Promise<void> {

        let dataSourceNames = bundle?.dataSources?.map(x => x.name.toLowerCase());

        let collections = await getCollections(bundle?.config?.regime as string, dataSourceNames);

        let dataSourcesInDb = [] as IngestionConfig[];

        collections.dataSources.forEach((ds) => {
            let name = ds.name.toLowerCase();

            if (dataSourceNames.includes(name) && !dataSourcesInDb.some(x => x.name.toLowerCase() === name)) {
                dataSourcesInDb.push(ds);
            }
        })

        this.setState({ dataSourcesInDb: dataSourcesInDb });

        await this.notifyUser(bundle, collections);
    }

    async tryGetValidationConfig(regime: string): Promise<ReportConfig | null> {

        let config = null;

        if (this.props.isValidationConfig) {

            let route = `report/regime/${regime}`;

            var response = await httpClient.get<ReportConfig>(route);

            config = response.data;
        }

        return config;
    }

    async notifyUser(bundle: ReportConfigBundle, collections: CollectionBundle): Promise<string> {

        let result = analyse(bundle, collections.reportFields, collections.dataSources);

        if (result.disabledClientDataSources.length > 0) {

            let message = `The following data sources are archived:\n${result.disabledClientDataSources.join('\n')}\n\nPlease unarchive them first`;

            this.props.onChange({ errors: [message] } as ImportReportConfigState);

            return Promise.reject(message);
        }

        if (result.missingReportFields.length > 0) {

            let message = `The following report fields are missing:\n${result.missingReportFields.join('\n')}`;

            this.setState({ showImportDataSourceModal: true, message, dataSourceAnalysisResult: result, bundle });

            return Promise.reject(message);
        }

        let validationConfig = await this.tryGetValidationConfig(bundle.config.regime)

        this.setState({ validationConfig });

        let updateError = validateUpdate(bundle, result, validationConfig);

        if (updateError) {

            this.props.onChange({ errors: [updateError] } as ImportReportConfigState);

            return updateError;
        }

        if (result.missingClientDataSources.length) {

            let message = `The following data sources were not found:\n\n${(result.missingClientDataSources).join('\n')}\n\nDo you want to import them ?`;

            this.setState({ showImportDataSourceModal: true, message, dataSourceAnalysisResult: result, bundle });
        }
        else {
            this.setState({ showImportDataSourceModal: false, dataSourceAnalysisResult: result });

            await this.onImportConfigConfirmed(result, bundle);
        }

        return '';
    }

    async onImportConfigConfirmed(result?: DataSourceAnalysisResult, bundle?: ReportConfigBundle): Promise<void> {

        bundle = bundle || copyObject(this.state.bundle) as ReportConfigBundle;

        result = result || copyObject(this.state.dataSourceAnalysisResult) as DataSourceAnalysisResult;

        if (result?.missingClientDataSources.length) {

            let reportConfigdataSourcesForImport = bundle?.dataSources.filter(y => result?.missingClientDataSources.includes(y.name.toLowerCase()));

            await importDataSources(reportConfigdataSourcesForImport as IngestionConfig[]);

            let response = await getDataSources(reportConfigdataSourcesForImport.map(x => x.name));

            let newDataSources = response.data;

            let dataSourcesInDb = copyArray(this.state.dataSourcesInDb);

            dataSourcesInDb = dataSourcesInDb.concat(newDataSources);
            addDatasourcesToResult(bundle.dataSources, newDataSources, result);

            this.setState({ dataSourcesInDb, dataSourceAnalysisResult: result });
        }

        if (result.maps) {

            let mismatchedDataSources: NameAndError[] = [];

            let errors = this.seedDataSource(bundle, result.maps, mismatchedDataSources);

            if (mismatchedDataSources.length) {
                this.setState({ bundle, mismatchedDataSources, showImportDataSourceModal: false, showNewDataSourcesNamesModal: true, showSpinner: false });
            }
            else if (errors.length) {
                this.props.onChange({ errors } as ImportReportConfigState);
            }
            else {
                if (bundle.config.globalModuleConfigId) {
                    await this.proceedWithGlobalModule(bundle.config);
                }
                else {
                    await this.showChanges(bundle, result.maps, this.state.validationConfig);
                }
            }
        }
    }

    seedDataSource(bundle: ReportConfigBundle, maps: IdMaps, mismatchedDataSources: NameAndError[]): string[] {
        let errors: Set<string> = new Set<string>();

        dataSourceFieldMapHelper.seed(bundle.dataSources, this.state.dataSourcesInDb, maps.dataSourceField, errors, mismatchedDataSources);

        return Array.from(errors);
    }

    async showChanges(bundle: ReportConfigBundle, maps: IdMaps, validationConfig?: ReportConfig | null): Promise<void> {

        reportConfigAdapter.adapt(bundle.config, maps);

        if (typeHelper.isObject(validationConfig)) {
            reportConfigComponentIdMapper.mapIds(bundle.config, validationConfig as ReportConfig);

            this.setState({ toImport: bundle.config, showSpinner: true });

            let route = urlHelper.buildRoute(['import', bundle.config.id, 'changes']);

            let response = await httpClient.post(route, bundle.config);

            this.setState({ toImport: bundle.config, showSpinner: false });

            this.onGetChangesSuccess(response.data);
        }
        else {
            await importReportConfig({ reportConfig: bundle.config, globalFunctions: bundle.globalModuleConfig?.userDefinedFunctions || [] });

            this.props.onImportSuccess();
        }
    }


    onShowDiffClick(value: ChangeDescription) {
        this.setState({ compareChanges: value });
    }

    onGetChangesSuccess(changes: ChangeDescription[]): void {

        let payload: ChangeLogModalState = {
            isOpen: true,
            title: 'Changes',
            columns: [moduleColumn, moduleRefColumn].concat(commonColumns(this.onShowDiffClick)),
            data: changes,
            error: null
        };

        store.dispatch({ type: actions.changeLogModal.open, payload: payload });
    }

    onSaveClick(): void {

        let payload: ChangeLogModalState = {
            isOpen: false,
            title: '',
            columns: [],
            data: [] as ChangeDescription[],
            error: null
        };

        store.dispatch({ type: actions.changeLogModal.close, payload: payload });

        importReportConfig({ reportConfig: this.state.toImport as ReportConfig, globalFunctions: this.state.bundle.globalModuleConfig?.userDefinedFunctions || [] }).then(this.props.onImportSuccess);

        this.props.onChange({} as ImportReportConfigState);
    }

    onDownloadClick(): Promise<void> {

        let config = this.state.toImport as ReportConfig;

        let route = urlHelper.buildRoute(['import', config.id, 'changes-download']);

        return httpClient.download(route, config);
    }

    onDataSourceRename(oldName: string, newName: string) {

        let renamedDataSourcesMap = new Map(this.state.renamedDataSources);

        renamedDataSourcesMap.set(oldName, newName);

        let mismatchedDataSources = copyArray(this.state.mismatchedDataSources)

        let ds = mismatchedDataSources.find(x => x.name === oldName);

        if (ds && newName) {
            ds.error = '';
        }
        else if (ds && !newName) {
            ds.error = emptyName;
        }

        this.setState({ renamedDataSources: renamedDataSourcesMap, mismatchedDataSources });
    }

    getNewDataSourceJsx() {
        return <div>
            {this.state.mismatchedDataSources.map((ds, index) => {
                return <div className='display-flex' key={index}>
                    <FormGroup
                        label={stringHelper.firstLetterToUpperRestToLower(ds.name)}
                        labelClassName='font-robotoBold'
                        containerClassName='form-group-horizontal'
                        style={{ 'display': 'flex' }}
                        key={ds.name}
                    >
                        <input
                            className='form-control margin-left-10px'
                            type='text'
                            placeholder='Type here'
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onDataSourceRename(ds.name, e.currentTarget.value)}
                        />
                        <p className='margin-left-10px error'>{ds.error}</p>
                    </FormGroup>
                </div>
            })
            }
        </div>
    }

    resetDataSourcesErrors(dataSources: NameAndError[]) {
        dataSources.forEach((ds) => {
            ds.error = '';
        })
    }

    async validateDataSourcesRename(): Promise<boolean> {

        let dataSources = copyArray(this.state.mismatchedDataSources);

        this.resetDataSourcesErrors(dataSources);

        let areNamesTyped = this.state.renamedDataSources.size === dataSources.length;

        dataSources.forEach((ds) => {

            let renamedDs = this.state.renamedDataSources.get(ds.name);

            if (!renamedDs) {
                ds.error = emptyName;

                areNamesTyped = false;
            }
        });

        let isRenameCorrect = true;

        if (areNamesTyped) {

            let newNames = Array.from(this.state.renamedDataSources.values());

            let response = await getDataSourcesByNames(newNames);

            let existingDataSources = response.data;

            dataSources = existingDataSources.length ? dataSources.filter(x => existingDataSources.map(x => x.name)) : [];

            dataSources.forEach((ds) => {
                ds.error = getComponentNameExistsError('DataSource', ds.name);

                isRenameCorrect = false;
            });
        }

        this.setState({ mismatchedDataSources: dataSources });

        return areNamesTyped && isRenameCorrect;
    }

    async onNewDataSourceNamesReady(): Promise<void> {

        let areNamesValid = await this.validateDataSourcesRename();

        if (areNamesValid) {

            let bundle = copyObject(this.state.bundle);

            let dataSources = bundle.dataSources.filter(x => this.state.dataSourceAnalysisResult.missingClientDataSources.includes(x.name) || this.state.renamedDataSources.has(x.name));

            dataSources.forEach((ds) => {
                if (this.state.renamedDataSources.has(ds.name)) {
                    ds.name = this.state.renamedDataSources.get(ds.name) as string;
                }
            });

            let renamedDataSources = new Map(this.state.renamedDataSources);

            this.closeNewDataSourceNameModal();

            await importDataSources(dataSources);

            let analysis = await this.updateWithNewDataSourcesFromDb(renamedDataSources);

            this.setState({ dataSourceAnalysisResult: analysis });

            if (bundle.config.globalModuleConfigId) {
                await this.proceedWithGlobalModule(bundle.config)
            }
            else {
                await this.showChanges(bundle, analysis.maps, this.state.validationConfig);
            }
        }
    }

    async updateWithNewDataSourcesFromDb(renamedDataSources: Map<string, string>): Promise<DataSourceAnalysisResult> {

        let oldNames = Array.from(renamedDataSources.keys());

        let newNames = Array.from(renamedDataSources.values());

        let response = await getDataSourcesByNames(newNames);

        let newDataSources = response.data;

        let oldDataSources = this.getOldDataSourcesWithNewNames(oldNames, renamedDataSources);

        let dataSourcesInDb = copyArray(this.state.dataSourcesInDb);

        renamedDataSources.forEach((value, key) => {

            let oldDs = dataSourcesInDb.find(x => x.name === key) as IngestionConfig;

            let newDs = newDataSources.find(x => x.name === value) as IngestionConfig;

            if (oldDs && newDs) {

                dataSourcesInDb = dataSourcesInDb.filter(x => x.name !== key);
                dataSourcesInDb.push(newDs);
            }
        });

        this.setState({ dataSourcesInDb });

        let errors = new Set<string>();

        let mismatchedDataSources: NameAndError[] = [];

        let analysis = copyObject(this.state.dataSourceAnalysisResult);

        this.updateAnalyssisDataSources(analysis, newDataSources, oldDataSources);

        dataSourceFieldMapHelper.seed(oldDataSources, newDataSources, analysis.maps.dataSourceField, errors, mismatchedDataSources);

        return analysis;
    }

    updateAnalyssisDataSources(dataSourceAnalysis: DataSourceAnalysisResult, newDataSources: IngestionConfig[], oldDataSources: IngestionConfig[]) {

        oldDataSources.forEach((ds) => {

            let newDataSource = newDataSources.find(x => x.name === ds.name) as IngestionConfig;

            let newId = newDataSource?.id as number;

            dataSourceAnalysis.maps.dataSource[ds.id as number] = newId;

            ds.fieldDefinitions.forEach((field) => {
                let newField = newDataSource.fieldDefinitions.find(x => x.name === field.name);

                dataSourceAnalysis.maps.dataSourceField[field.id as number] = newField?.id as number;
            })
        });

    }

    getOldDataSourcesWithNewNames(oldNames: string[], renamedDataSources: Map<string, string>) {

        let oldDataSources = this.state.bundle.dataSources.filter(x => oldNames.includes(x.name));

        oldDataSources.forEach((ds) => {
            ds.name = renamedDataSources.get(ds.name) as string;
        });

        return oldDataSources;
    }

    getRenameJsx(error: string, onChange: (e: React.ChangeEvent<HTMLInputElement>) => void): JSX.Element {
        return <div className='display-flex'>
            <FormGroup
                label='New Name'
                labelClassName='font-robotoBold'
                containerClassName='form-group-horizontal'
                style={{ 'display': 'flex' }}
            >
                <input
                    className='form-control margin-left-10px'
                    type='text'
                    placeholder='Type here'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
                />
                <p className='margin-left-10px error'>{error}</p>
            </FormGroup>
        </div>
    }

    onReportNameChangeConfirmed() {

        if (this.state.reportNewName.length > 100 || this.state.reportNewName.length < 3) {
            this.setState({ reportNameError: 'Report config name must have length between 3 and 100 characters' });
        }
        else if (this.state.reportNewName.length) {

            httpClient.get<boolean>(`report/validate-name/${this.state.reportNewName}`)
                .then((resp) => {

                    if (!resp.data) {

                        this.setState({ showNewConfigNamePopup: false });

                        let bundle = copyObject(this.state.bundle);

                        bundle.config.name = this.state.reportNewName;

                        this.proceedWithImport(bundle);
                    }
                    else {
                        this.setState({ reportNameError: getComponentNameExistsError('Report config', this.state.reportNewName) })
                    }
                });
        }
        else {
            this.setState({ reportNameError: 'Invalid config name' });
        }
    }

    closeNewDataSourceNameModal() {
        this.setState({
            showNewDataSourcesNamesModal: false, mismatchedDataSources: [], renamedDataSources: new Map(), showSpinner: false
        });
    }

    async getChanges(analysisResult: GlobalModuleComponentsAnalysisResult): Promise<ChangeDescription[]> {

        let lookupNames = analysisResult.existingLookups.map(x => x.name.toLowerCase());
        let udfpNames = analysisResult.existingUserDefinedFunctions.map(x => x.name.toLowerCase());
        let variableNames = analysisResult.existingVariables.map(x => x.name.toLowerCase());

        let config1 = getEmptyReportConfig();

        config1.userDefinedFunctions = copyArray(this.state.bundle.config.userDefinedFunctions.filter(x => udfpNames.includes(x.name.toLowerCase())));
        config1.variables = copyArray(this.state.bundle.config.variables.filter(x => variableNames.includes(x.name.toLowerCase())));
        config1.refDataSources = this.prepareDataSourcesForReportConfigChanges();

        let lookups = copyArray(this.state.bundle.config?.lookups?.filter(x => lookupNames.includes(x.name.toLowerCase())) || []);
        config1.lookups = this.prepareLookupsForGetChanges(config1, this.state.bundle.config?.lookups, lookups);

        let config2 = getEmptyReportConfig();

        config2.userDefinedFunctions = copyArray(this.state.currentGlobalModuleConfig?.userDefinedFunctions?.filter(x => udfpNames.includes(x.name.toLowerCase())) || []);
        config2.variables = copyArray(this.state.currentGlobalModuleConfig?.variables?.filter(x => variableNames.includes(x.name.toLowerCase())) || []);
        config2.refDataSources = copyArray(this.state.currentGlobalModuleConfig?.refDataSources || []);

        lookups = copyArray(this.state.currentGlobalModuleConfig?.lookups?.filter(x => lookupNames.includes(x.name.toLowerCase())) || []);
        config2.lookups = this.prepareLookupsForGetChanges(config2, this.state.currentGlobalModuleConfig?.lookups, lookups);

        this.prepareComponents(config1);
        this.prepareComponents(config2);

        resetConfigComponentsBeforeGetChanges(config1);
        resetConfigComponentsBeforeGetChanges(config2);

        let requestObject = { previous: config1, current: config2 } as ComparisonPair;

        let response = await httpClient.post('import/global-components/changes', requestObject);

        return response.data;
    }

    prepareLookupsForGetChanges(config: ReportConfig, allLookups: Lookup[], filteredLookups: Lookup[]): Lookup[] {

        let lookups = filteredLookups;

        var relatedLookups = this.getRelatedLookups(allLookups);

        let lookupsReferencedInVariables = this.getRelatedLookupsInVariables(config.variables, allLookups);

        lookups = lookups.concat(lookupsReferencedInVariables);

        relatedLookups.forEach((l) => {
            if (!lookupsReferencedInVariables.find(x => x.id === l.id)) {
                lookups.push(l);
            }
        });

        reportConfigAdapter.adaptLookups(lookups, this.state.dataSourceAnalysisResult.maps);

        return lookups;
    }

    getRelatedLookupsInVariables(variables: ReportVariable[], allLookups: Lookup[]): Lookup[] {

        let resultLookups = [] as Lookup[];

        variables.forEach((v) => {
            operandHelper.proceedWhitAssignment(v.assignment, (operand: Operand) => {
                if (operand.lookupNumber) {
                    resultLookups.push(allLookups.find(x => x.number === operand.lookupNumber) as Lookup);
                }
            });
        });

        return resultLookups;
    }

    getRelatedLookups(lookups: Lookup[]): Lookup[] {

        let lookupIds = lookups.map(x => x.id);

        let resultLookups = [] as Lookup[];

        lookups.forEach((lookup) => {

            let referencedLookups = getReferencedGlobalLookups(this.state.bundle.config, this.state.bundle.globalModuleConfig as GlobalModuleConfig, lookup.globalLookupModuleId as number);

            referencedLookups.forEach((referenced) => {
                if (!lookupIds.includes(referenced.id) && !resultLookups.map(x => x.id).includes(referenced.id)) {
                    resultLookups.push(referenced);
                }
            });
        });

        return resultLookups;
    }

    prepareDataSourcesForReportConfigChanges() {

        let result = [] as RefDataSource[];

        this.state.dataSourcesInDb.forEach((ds) => {
            result.push({
                runStatus: 0,
                fieldDefinitions: ds.fieldDefinitions,
                name: ds.name,
                kind: ds.dataSourceKind,
                id: ds.id
            } as RefDataSource)
        });

        return result;
    }

    async proceedWithGlobalModule(reportConfig: ReportConfig): Promise<void> {

        let currentGlobalModule = copyObject(this.state.currentGlobalModuleConfig);

        let result = analyseGlobalModuleComponents(currentGlobalModule, reportConfig);

        this.setState({ globalModuleComponentsAnalysisResult: result } as ImportConfigState);

        if (result.existingLookups.length || result.existingUserDefinedFunctions.length || result.existingVariables.length) {

            let changes = await this.getChanges(result);

            this.setState({ globalModuleComponentsAnalysisResult: result, componentsChanges: changes.filter(x => x.moduleComponent === 'Logic'), showEditGlobalComponentsPopup: true });
        }
        else {

            if (Object.keys(currentGlobalModule).length > 0) {
                await this.updateGlobalModule(currentGlobalModule, result, this.state.dataSourceAnalysisResult.maps);

                let currentGlobalModuleConfig = await this.getCurrentGlobalModule();

                this.setState({ currentGlobalModuleConfig });
            }

            let bundle = this.updateReportConfigWithMissingGlobalComponents(result);

            await this.showChanges(bundle, this.state.dataSourceAnalysisResult.maps, this.state.validationConfig);
        }
    }

    async getCurrentGlobalModule(): Promise<GlobalModuleConfig> {
        let response = await httpClient.get<GlobalModuleConfig>('report/global-module');

        return response.data
    }

    updateReportConfigWithMissingGlobalComponents(result: GlobalModuleComponentsAnalysisResult): ReportConfigBundle {

        let bundle = copyObject(this.state.bundle);

        this.updateReportConfigComponentsGlobalModuleId(bundle.config);

        return bundle;
    }

    updateReportConfigComponentsGlobalModuleId(reportConfig: ReportConfig) {

        reportConfig.lookups.forEach((l) => {
            if (l.mode === Mode.Global) {
                l.globalLookupModuleId = this.state.currentGlobalModuleConfig.lookups.find(x => x.name === l.name)?.id || 0;
            }
        });

        reportConfig.variables.forEach((l) => {
            if (l.mode === Mode.Global) {
                l.globalVariableModuleId = this.state.currentGlobalModuleConfig.variables.find(x => x.name === l.name)?.id || 0;
            }
        });

        reportConfig.userDefinedFunctions.forEach((l) => {
            if (l.mode === Mode.Global) {
                l.globalUDFModuleId = this.state.currentGlobalModuleConfig.userDefinedFunctions.find(x => x.name === l.name)?.id || 0;
            }
        });
    }

    updateReportConfigComponentsOperands(lookupsMap: Map<number, number>, variablesMap: Map<number, number>, reportConfig: ReportConfig) {

        operandHelper.traverseReportConfigSectionsForOperands(reportConfig, (operand: Operand) => {
            if (operand.lookupNumber) {

                let newNumber = lookupsMap.get(operand.lookupNumber);

                if (newNumber) {
                    operand.lookupNumber = newNumber;
                }
            }

            if (operand.variableNumber) {

                let newNumber = variablesMap.get(operand.variableNumber);

                if (newNumber) {
                    operand.variableNumber = newNumber;
                }
            }
        });
    }

    prepareMap(collection: IdNameAndNumber[], collectionToIterate: IdNameAndNumber[], map: Map<number, number>) {

        let missingNames = collection.map(x => x.name);

        collectionToIterate.forEach((component) => {
            if (missingNames.includes(component.name)) {

                let newNumber = collection.find(x => x.name === component.name)?.number as number;

                if (newNumber !== component.number) {
                    map.set(component.number, newNumber);
                }
            }
        });
    }

    prepareAssignment(assignment: Assignment) {

        operandHelper.proceedWhitAssignment(assignment, (operand: Operand) => {
            if (operand.fieldId && this.state.dataSourceAnalysisResult.maps.dataSourceField[operand.fieldId]) {
                operand.fieldId = this.state.dataSourceAnalysisResult.maps.dataSourceField[operand.fieldId];
            }
        });
    }

    prepareCondition(condition: Condition) {

        operandHelper.proceedWhitCondition(condition, (operand: Operand) => {
            if (operand.fieldId && this.state.dataSourceAnalysisResult.maps.dataSourceField[operand.fieldId]) {
                operand.fieldId = this.state.dataSourceAnalysisResult.maps.dataSourceField[operand.fieldId];
            }
        });
    }

    prepareComponents(reportConfig: Config) {

        let datasourcesMap = this.state.dataSourceAnalysisResult.maps.dataSource;

        reportConfig.lookups.forEach((l) => {
            this.prepareCondition(l.condition);

            if (datasourcesMap[l.dataSource1Id as number]) {
                l.dataSource1Id = datasourcesMap[l.dataSource1Id as number];
            }

            if (datasourcesMap[l.dataSource2Id as number]) {
                l.dataSource2Id = datasourcesMap[l.dataSource2Id as number];
            }
        });

        reportConfig.variables.forEach((v) => {
            this.prepareAssignment(v.assignment);

            if (datasourcesMap[v.dataSourceId as number]) {
                v.dataSourceId = datasourcesMap[v.dataSourceId as number];
            }
        });

        reportConfig.userDefinedFunctions.forEach((udf) => {
            this.prepareAssignment(udf.assignment);

            if (datasourcesMap[udf.dataSourceId as number]) {
                udf.dataSourceId = datasourcesMap[udf.dataSourceId as number];
            }
        });
    }

    onMismatchedGlobalComponentsOkClick() {
        this.setState({ showSpinner: false });

        this.props.onImportSuccess();
    }

    async updateGlobalModule(currentGlobalModule: GlobalModuleConfig, result: GlobalModuleComponentsAnalysisResult, maps: IdMaps): Promise<void> {

        this.updateCurrentGlobalModuleDataSources(currentGlobalModule, maps);

        this.updateComponentsNumbers(this.getNextNumber(currentGlobalModule.lookups), result.missingLookups as IdNameAndNumber[]);

        currentGlobalModule.lookups = currentGlobalModule.lookups.concat(result.missingLookups);

        let missingLookupsNames = result.missingLookups.map(y => y.name);

        let lookupsForUpdate = currentGlobalModule.lookups.filter(x => missingLookupsNames.includes(x.name));

        updateLookupsDataSources(lookupsForUpdate, maps);

        this.updateComponentsNumbers(this.getNextNumber(currentGlobalModule.userDefinedFunctions), result.missingUserDefinedFunctions as IdNameAndNumber[]);
        currentGlobalModule.userDefinedFunctions = currentGlobalModule.userDefinedFunctions.concat(result.missingUserDefinedFunctions);

        this.updateComponentsNumbers(this.getNextNumber(currentGlobalModule.variables), result.missingVariables as IdNameAndNumber[]);
        currentGlobalModule.variables = currentGlobalModule.variables.concat(result.missingVariables);

        this.prepareComponents(currentGlobalModule);

        await httpClient.put('report/global-module', currentGlobalModule);
    }

    updateCurrentGlobalModuleDataSources(currentGlobalModule: GlobalModuleConfig, maps: IdMaps) {

        this.state.bundle.globalModuleDataSources?.forEach((ds) => {

            let newId = maps.dataSource[ds.id as number];

            if (newId) {
                currentGlobalModule.refDataSources.push({
                    id: newId,
                    name: ds.name,
                    dataSourceKind: ds.dataSourceKind,
                    fieldDefinitions: ds.fieldDefinitions,
                    runStatus: 0
                } as RefDataSource);
            }
        })
    }

    getNextNumber(components: { number: number }[]): number {

        return (components || []).reduce((max, x) => Math.max(max, x.number || 0), 0) + 1;
    }

    updateComponentsNumbers(collectionCount: number, components: IdNameAndNumber[]) {

        let number = collectionCount;

        components.forEach((c) => {

            c.number = number;
            number++;
        });
    }

    prepareMismatchedComponentsForPopup(): ComponentInPopup[] {
        let components = [] as ComponentInPopup[];

        this.state.globalModuleComponentsAnalysisResult.existingLookups.forEach((l) => {
            components.push({ name: l.name, componentType: ComponentType.Lookup, showNewNameInput: true, useUpdateLogic: false, error: '' });
        });

        this.state.globalModuleComponentsAnalysisResult.existingUserDefinedFunctions.forEach((udf) => {
            components.push({ name: udf.name, componentType: ComponentType.UserDefinedFunction, showNewNameInput: true, useUpdateLogic: false, error: '' });
        });

        this.state.globalModuleComponentsAnalysisResult.existingVariables.forEach((v) => {
            components.push({ name: v.name, componentType: ComponentType.Variable, showNewNameInput: true, useUpdateLogic: false, error: '' });
        });

        return components;
    }

    render(): JSX.Element {

        return (
            <>
                {!this.state.showNewDataSourcesNamesModal &&
                    <div className="row no-gutters display-flex align-items-center">
                        <div className="col-auto">
                            {this.props.children}
                        </div>
                        <div className="col-auto mr-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Paste Config Source"
                                value={this.props.state.json}
                                onChange={this.onSourceChange} />
                        </div>
                        {this.state.showSpinner && this.state.isOpen ?
                            <button id='spinnerWrapper' className='btn cb-btn width-75px' disabled>Import<Spinner /></button>
                            :
                            <button className="btn cb-btn" onClick={this.onImportClick} >Import</button>
                        }
                    </div>
                }

                <ErrorList className="mt-2" errors={this.props.state.errors} />

                <ChangeLogModal>
                    <button className="btn btn-light" onClick={this.onDownloadClick}>Download</button>
                    <button className="btn cb-btn" onClick={this.onSaveClick}>Save</button>
                </ChangeLogModal>
                {
                    this.state.showImportDataSourceModal &&
                    <WarningModal
                        onOkClick={() => { this.setState({ showImportDataSourceModal: false }); this.onImportConfigConfirmed(); }}
                        onCancelClick={() => this.setState({ showImportDataSourceModal: false, showSpinner: false })}
                        title='Import data sources'
                        message={this.state.message} />
                }
                {this.state.showNewDataSourcesNamesModal &&
                    <WarningModal
                        onOkClick={this.onNewDataSourceNamesReady}
                        onCancelClick={this.closeNewDataSourceNameModal}
                        title='Rename data sources'
                        children={this.getNewDataSourceJsx()}
                        message={'There is mismatched datasources. Please type new names for them'}
                        showSpinnerOnOkClick={this.state.showSpinner} />
                }
                {this.state.showNewConfigNamePopup &&
                    <WarningModal
                        onOkClick={this.onReportNameChangeConfirmed}
                        onCancelClick={() => this.setState({ showNewConfigNamePopup: false, showSpinner: false })}
                        title='Rename report config name'
                        children={this.getRenameJsx(this.state.reportNameError, (e) => this.setState({ reportNewName: e.currentTarget.value }))}
                        message={`A report with name "${this.state.bundle.config.name}" already exists. Please type new name for the report`} />
                }
                {this.state.showEditGlobalComponentsPopup &&
                    <GlobalModuleComponents
                        onCancelClick={() => this.setState({ showEditGlobalComponentsPopup: false, showSpinner: false })}
                        onMismatchedGlobalComponentsOkClick={this.onMismatchedGlobalComponentsOkClick}
                        bundle={this.state.bundle}
                        currentGlobalModuleConfig={this.state.currentGlobalModuleConfig}
                        dataSourceAnalysisResult={this.state.dataSourceAnalysisResult}
                        components={this.prepareMismatchedComponentsForPopup()}
                        onChange={this.props.onChange}
                        setState={this.setState}
                        componentsChanges={this.state.componentsChanges}
                        globalModuleComponentsAnalysisResult={this.state.globalModuleComponentsAnalysisResult}
                        dataSources={this.state.dataSourcesInDb}
                    />
                }

            </>
        );
    }
}

export default ImportReportConfig;
